import React from "react";
import "./index.scss";
import Chart from "devextreme-react/chart";
import { IMdaeChartOptions } from "./index";
import { useDispatch } from "react-redux";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";

const MdaeChart: React.FC<IMdaeChartOptions> = (props) => {
  const dispatch = useDispatch();
  return (
      <Chart
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_CHART,
            e.component,
            dispatch
          );
        }}
      ></Chart>
  );
};
export default MdaeChart;
